import React, { FC } from 'react';

import { Box, Flex, Heading, Stack } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { MdGroups2, MdFactCheck, MdLocalPolice } from 'react-icons/md';

import { CustomText } from '@components/Custom-text';

type WhyChooseYourYodaItemProps = {
    Icon: IconType;
    title: string;
    description: string;
};

const WhyChooseYourYodaItem: FC<WhyChooseYourYodaItemProps> = ({ Icon, title, description }) => (
    <Stack flex={1} gap={4} alignItems="center">
        <Flex
            w="48px"
            h="48px"
            justifyContent="center"
            alignItems="center"
            borderRadius="24px"
            bgColor="green.600"
        >
            <Box>
                <Icon size="32px" color="white" />
            </Box>
        </Flex>
        <CustomText textAlign="center" color="mainText" weight={500} size="xl">
            {title}
        </CustomText>
        <CustomText textAlign="center" color="shadowSlate" size="sm">
            {description}
        </CustomText>
    </Stack>
);

export const WhyChooseYourYoda = () => (
    <Stack
        py={{ base: 10, md: 20 }}
        mt={{ base: 10, md: 20 }}
        mx={{ base: 0, md: -10, lg: -20 }}
        px={{ base: 6, md: 16 }}
        align="center"
        justify="center"
        backgroundColor="successBg"
    >
        <Heading fontWeight="medium" textAlign="center" color="mainText">
            Why Choose YourYoda?
        </Heading>
        <CustomText color="shadowSlate" textAlign="center" size="md">
            Grow faster with expert guidance, actionable roadmaps, and a supportive career
            community.
        </CustomText>
        <Flex
            align="flex-start"
            justifyContent="space-between"
            gap={20}
            w="85%"
            pt={{ base: 10, md: 10 }}
            px={{ base: 6, md: 0 }}
            direction={{ base: 'column', md: 'row' }}
        >
            <WhyChooseYourYodaItem
                Icon={MdGroups2}
                title="Be Part of the Inner Circle"
                description="Get exclusive access to our private community group — connecting all mentors and
                    mentees for quick answers, idea sharing, and real-time support beyond your
                    sessions."
            />
            <WhyChooseYourYodaItem
                Icon={MdFactCheck}
                title="Clear Roadmap After Every Session"
                description="Receive a full session transcript and a personalized action plan so you know exactly what to do next."
            />
            <WhyChooseYourYodaItem
                Icon={MdLocalPolice}
                title="100% Session Satisfaction Guarantee"
                description="If a session doesn’t meet your expectations, we review it and credit it back — no questions asked."
            />
        </Flex>
    </Stack>
);
